export const TRANSACTIONS_DETAILS_OPEN_MODAL = "TRANSACTIONS_DETAILS_OPEN_MODAL";
export const TRANSACTIONS_DETAILS_CLOSE_MODAL = "TRANSACTIONS_DETAILS_CLOSE_MODAL";
export const TRANSACTIONS_DETAILS_RESULT_REQUEST = "TRANSACTIONS_DETAILS_RESULT_REQUEST";
export const TRANSACTIONS_DETAILS_RESULT_RESULT = "TRANSACTIONS_DETAILS_RESULT_RESULT";